import React, { useRef, useEffect, useState, useCallback } from "react";
import {
    Tab,
    TabList,
    Spinner,
    makeStyles,
  } from "@fluentui/react-components"; 
import {
    DocumentEndnote24Filled,
    DocumentEndnote24Regular,
    DocumentText24Filled,
    DocumentText24Regular,
    Note24Filled,
    Note24Regular,
    bundleIcon,
  } from "@fluentui/react-icons";  

//import ProcedureRow from "./ProcedureRow";
import RelationContactRow from "./RelationContactRow";

//import ProcedureInfo from "./ProcedureInfo";
import RelationContactInfo from "./RelationContactInfo";

import MeetingFimForms from "../fim/MeetingFimForms";
import useSize from "@react-hook/size";
import Notes from "../note/Notes";
import { customTokens } from "../../utils/Theming";
import { useDispatch, useSelector } from "react-redux";

//import { setProcedureOoid } from "./procedure-slice";
//import { fetchProcedure } from "./procedure-slice";

import { setRelationContactOoid } from "./relationContact-slice";
import { fetchRelationContact } from "./relationContact-slice";

const DocumentEndnote24 = bundleIcon(DocumentEndnote24Filled, DocumentEndnote24Regular);
const DocumentText24 = bundleIcon(DocumentText24Filled, DocumentText24Regular);
const Note24 = bundleIcon(Note24Filled, Note24Regular);

// const useBaseClassName = makeResetStyles({
// });
const useStyles = makeStyles({
   staticRow: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: customTokens.colorNeutralBackground7
   }
});

export default function RelationContactPage({ooid, fim_forms}) {
    console.log('RelationContactPage', ooid);

    const {relationContact} = useSelector(state => state.relationContact);
    const dispatch = useDispatch();
    // const baseClassName = useBaseClassName();
    const classes = useStyles();
    const target = useRef(null);
    const [tab, setTab] = useState('tab2');
    const [additionalTabList, setAdditionalTabList] = useState(null);
    const [width, ] = useSize(target);

    let tablistSize = 'small';
    if (width > 275){
        tablistSize = 'medium'
    }
    let tabInfoText = 'Info';
    let tabNotesText = 'P - Notes';
    if (width > 375) {
        tabInfoText = 'Information';
        tabNotesText = 'Contact Notes';
    
    }

    useEffect(() => {
        dispatch(setRelationContactOoid(ooid));
        dispatch(fetchRelationContact());
    }, [ooid, dispatch]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [tab]);

    const handleMoreTabs = useCallback((tabs) => {setAdditionalTabList(tabs);}, [setAdditionalTabList]);

    const renderTab = () => {
        switch (tab) {
            case 'tab1':
                return <MeetingFimForms items={fim_forms} entity="RelationContact" ooid={ooid} onAddTabs={handleMoreTabs}></MeetingFimForms>;
            case 'tab2':
                return <RelationContactInfo ooid={ooid} relationContact={relationContact} onAddTabs={handleMoreTabs}></RelationContactInfo>;
            case 'tab3':
                return <Notes ooid={ooid} type='relationContact'></Notes>;
            default:
                return null;
        }
    };

    let componentContent = <Spinner label="I am definitely loading..." />;
    if (relationContact) {
        componentContent = (
            <>
                <div className={classes.staticRow}>
                    <RelationContactRow relationContact={relationContact} />
                    <TabList selectedValue={tab} onTabSelect={(e, {value}) => setTab(value)} size={tablistSize}>
                        {fim_forms && (<Tab icon={<DocumentEndnote24 />} value="tab1">{fim_forms.length >= 2 ? ('IForms') : ('IForm')}</Tab>)}
                        <Tab icon={<DocumentText24 />} value="tab2">{tabInfoText}</Tab>
                        <Tab icon={<Note24 />} value="tab3">{tabNotesText}</Tab>                
                    </TabList>
                    {additionalTabList}
                </div>
                {renderTab()}
            </>
        );
    }

    return (
        <div ref={target}>
            {componentContent}
        </div>
    );
}